import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    text: String,
    sourceId: String,
    successLabel: { type: String, default: "Copied" },
    defaultLabel: String
  }

  copy() {
    const original = this.element.innerHTML
    const text = this.hasSourceIdValue ? this.sourceText() : this.textValue

    window.writeClipboardText(text || "").then(() => {
      this.setLabel(this.successLabelValue)
      window.setTimeout(() => {
        this.element.innerHTML = original
      }, 1200)
    }).catch(() => {
      this.setLabel("Copy failed")
      window.setTimeout(() => {
        this.element.innerHTML = original
      }, 1200)
    })
  }

  sourceText() {
    const source = document.getElementById(this.sourceIdValue)
    if (!source) return ""

    const code = source.querySelector("code") || source
    return code.textContent || ""
  }

  setLabel(label) {
    const target = this.element.querySelector("[data-copy-label]")
    if (target) {
      target.textContent = label
    } else {
      this.element.textContent = label
    }
  }
}
